import {
	SET_APP_STATE,
	SET_USER,
	SET_EMAIL,
	SET_CURRENT_SCREEN,
	SET_SHOW_PROOFS,
	SET_SHOW_QUESTIONS_IN_DIVISIONS,
	SET_PROGRESS_MESSAGE,
	SET_PROGRESS_PERCENTAGE,
	SET_IS_AUDIO_PRESENTATION_MODE,
	SET_PLAYER_IS_SHOWN,
	SET_PLAYER_SIZE,
	SET_AUDIO_IS_ALT,
} from './AppActions';
import setPref from '../../OneHat/functions/setPref';
import { setQuestion, setQuestionById, setDivisionById, } from '../Thunks/setQuestion'; // I was getting circular dependency errors, so I combined lots of functions in this file
import setUpAudio from '../Thunks/setUpAudio';
import AppGlobals from '../../AppGlobals';


export default {
	// App Globals
	setAppState: (appState) => {
		return {
			type: SET_APP_STATE,
			appState, // 'active' || 'inactive' || 'background'
		};
	},
	setUser: (user) => {
		return {
			type: SET_USER,
			user,
		};
	},
	setEmail: (email) => {
		return {
			type: SET_EMAIL,
			email,
		};
	},
	setCurrentScreen: (currentScreen) => {
		return {
			type: SET_CURRENT_SCREEN,
			currentScreen,
		};
	},
	setQuestionById, // thunk
	setDivisionById, // thunk

	setAnimatedLyrics: (bool) => {
		return {
			type: SET_IS_AUDIO_PRESENTATION_MODE,
			bool,
		};
	},
	setShowProofs: (bool) => {
		return {
			type: SET_SHOW_PROOFS,
			bool,
		};
	},
	setPlayerSize: (size) => {
		return {
			type: SET_PLAYER_SIZE,
			size,
		};
	},
	setPlayerIsShown: (bool) => {
		return {
			type: SET_PLAYER_IS_SHOWN,
			bool,
		};
	},
	setProgressMessage: (message) => {
		return {
			type: SET_PROGRESS_MESSAGE,
			message,
		};
	},
	setProgressPercentage: (percentage) => {
		return {
			type: SET_PROGRESS_PERCENTAGE,
			percentage,
		};
	},

	// AudioPlayer - These get routed to audioPlayer.
	// The audioPlayer can then dispatch its own events to Redux as needed.
	setUpAudio, // thunk
	tearDownAudio: () => { // thunk
		return () => {
			AppGlobals.audioPlayer.tearDown();
		};
	},
	setQuestion, // thunk
	play: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.play();
		};
	},
	pause: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.pause();
		};
	},
	togglePlayback: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.togglePlayback();
		};
	},
	toggleIsAlt: () => { // thunk
		return (dispatch, getState) => {
			const {
				currentQuestion,
				audioIsAlt,
			} = getState().App;

			const bool = !audioIsAlt;
			dispatch({
				type: SET_AUDIO_IS_ALT,
				bool,
			});
			currentQuestion.saveIsAlt(bool);
			setQuestionById(currentQuestion.id)(dispatch, getState);
		};
	},
	toggleShowQuestionsInDivisions: () => { // thunk
		return (dispatch, getState) => {
			const {
				showQuestionsInDivisions,
			} = getState().App;

			const bool = !showQuestionsInDivisions;
			dispatch({
				type: SET_SHOW_QUESTIONS_IN_DIVISIONS,
				bool,
			});
			setPref('showQuestionsInDivisions', bool);
		};
	},
	setShowQuestionsInDivisions: (bool) => {
		return {
			type: SET_SHOW_QUESTIONS_IN_DIVISIONS,
			bool,
		};
	},
	startScrubbing: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.startScrubbing();
		};
	},
	endScrubbing: (value) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.endScrubbing(value);
		};
	},
	scrub: (time) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.scrub(time);
		};
	},
	scrubToPercentage: (time) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.scrubToPercentage(time);
		};
	},
	setVolume: (volume) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setVolume(volume);
		};
	},
	setRate: (rate) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setRate(rate);
		};
	},
	setIsKaraoke: (bool) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setIsKaraoke(bool);
		};
	},
	toggleIsKaraokeMode: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.toggleIsKaraokeMode();
		};
	},
	setIsLooping: (bool) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setIsLooping(bool);
		};
	},
	toggleIsLooping: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.toggleIsLooping();
		};
	},
	setIsAutoAdvance: (bool) => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setIsAutoAdvance(bool);
		};
	},
	toggleIsAutoAdvance: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.toggleIsAutoAdvance();
		};
	},
	toggleIsLyricsMode: () => { // thunk
		return async (dispatch, getState) => {
			const {
				audioIsLyricsMode,
			} = getState().App,
			bool = !audioIsLyricsMode;
			dispatch({
				type: SET_IS_AUDIO_PRESENTATION_MODE,
				bool,
			});
			setPref('audioIsLyricsMode', bool);
		};
	},
	setLoopingType: (loopingType) => {
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setLoopingType(loopingType);
		};
	},
	duck: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.duck();
		};
	},
	unduck: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.unduck();
		};
	},
	setPulserActive: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setPulserActive();
		};
	},
	setPulserInactive: () => { // thunk
		return (dispatch, getState) => {
			AppGlobals.audioPlayer.setPulserInactive();
		};
	},
};
